import { j as t } from "../../../../../../node_modules/react/jsx-runtime.js";
import { memo as i } from "react";
import { clsx as a } from "../../../../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as r } from "../../../../../atoms/Typography/Typography.js";
import m from "../../TableActions/TableActions.js";
import f from "../../../Table.module.scss.js";
import { i18n as l } from "../../../../../../utils/locale/locale.js";
const x = ({ actions: e, selected: o, total: s }) => /* @__PURE__ */ t.jsxs(
  "div",
  {
    className: a(f.tableBulkActions, {
      "justify-between": o && s && (e == null ? void 0 : e.length)
    }),
    "data-testid": "table-bulk-actions",
    children: [
      Number(o) > 0 && Number(s) > 0 && /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-025", children: [
        /* @__PURE__ */ t.jsx(
          r,
          {
            text: l("selected_records"),
            variant: "interface/default/s",
            textColor: "color/fg/lightest"
          }
        ),
        /* @__PURE__ */ t.jsx(
          r,
          {
            text: o,
            variant: "interface/strong/s",
            textColor: "color/fg/bold"
          }
        ),
        /* @__PURE__ */ t.jsx(
          r,
          {
            text: l("of"),
            variant: "interface/default/s",
            textColor: "color/fg/lightest"
          }
        ),
        /* @__PURE__ */ t.jsx(
          r,
          {
            text: s,
            variant: "interface/strong/s",
            textColor: "color/fg/bold"
          }
        )
      ] }),
      !!e && e.length > 0 && /* @__PURE__ */ t.jsx(m, { actions: e })
    ]
  }
), j = i(x);
export {
  j as default
};
//# sourceMappingURL=TableBulkActions.js.map
